
import * as React from "react"
import { ChevronRight } from "lucide-react"
import { cn } from "@/lib/utils"

export interface BreadcrumbItem {
  title: string
  href?: string
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
  separator?: React.ComponentType<{ className?: string }>
}

export function Breadcrumbs({ items, separator: Separator = ChevronRight }: BreadcrumbsProps) {
  return (
    <nav aria-label="breadcrumbs" className="text-xs">
      <ol className="flex items-center space-x-1">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          return (
            <li key={index} className="flex items-center space-x-1">
              {item.href ? (
                <a
                  href={item.href}
                  className={cn(
                    "hover:text-[#0f2d69] transition-colors",
                    isLast ? "text-[#0f2d69] font-semibold" : "text-gray-500"
                  )}
                >
                  {item.title}
                </a>
              ) : (
                <span className={cn(
                  isLast ? "text-[#0f2d69] font-semibold" : "text-gray-500"
                )}>
                  {item.title}
                </span>
              )}
              {!isLast && (
                <Separator className="h-3 w-3 text-gray-400" />
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
